import React from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";

const AppLoader = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        px: 2,
      }}
    >
      <Box
        sx={{
          width: "min(100%, 460px)",
          p: { xs: 3.5, md: 4.5 },
          borderRadius: 8,
          background:
            "radial-gradient(circle at top right, rgba(96,165,250,0.22), transparent 28%), linear-gradient(180deg, rgba(255,255,255,0.95), rgba(248,250,252,0.92))",
          border: "1px solid rgba(255,255,255,0.86)",
          boxShadow: "0 36px 90px rgba(15, 23, 42, 0.12)",
        }}
      >
        <Stack spacing={2.2} alignItems="center" textAlign="center">
          <Box
            sx={{
              width: 68,
              height: 68,
              display: "grid",
              placeItems: "center",
              borderRadius: "24px",
              color: "white",
              background:
                "linear-gradient(135deg, rgba(37,99,235,1), rgba(15,118,110,0.92))",
              boxShadow: "0 18px 42px rgba(37, 99, 235, 0.25)",
            }}
          >
            <CircularProgress size={28} thickness={4.4} sx={{ color: "white" }} />
          </Box>

          <Box>
            <Typography variant="h3" sx={{ mb: 0.7 }}>
              VenTush
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Syncing your timeline and preparing today&apos;s priorities.
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default AppLoader;
